import { HubspotFormFieldProps } from "./HubspotFormField";

export const FIELD_PRESETS: Record<string, HubspotFormFieldProps> = {
  FIRST_NAME: {
    label: "First name",
    type: "text",
    name: "firstname",
    isRequired: true,
  },
  LAST_NAME: {
    label: "Last name",
    type: "text",
    name: "lastname",
    isRequired: true,
  },
  EMAIL: {
    label: "Email",
    type: "text",
    name: "email",
    isRequired: true,
  },
  JOB_TITLE: {
    label: "Job title",
    type: "text",
    name: "jobtitle",
    isRequired: true,
  },
  PHONE_NUMBER: {
    label: "Phone number",
    type: "phone",
    name: "phone",
    isRequired: true,
  },
  NO_OF_EMPLOYEES: {
    label: "Number of employees",
    type: "select",
    name: "number_of_employees_string",
    isRequired: true,
    options: [
      "1 - 2",
      "3 - 20",
      "21 - 50",
      "51 - 100",
      "101 - 250",
      "251 - 500",
      "501 - 2500",
      "2500+",
    ].join("\n"),
  },
  HOW_DID_YOU_HEAR_ABOUT_US: {
    label: "How did you hear about us?",
    type: "text",
    name: "how_did_you_hear_about_us_",
    isRequired: true,
  },
  WHICH_PRODUCTS: {
    label: "Which products are you most interested in?",
    type: "multiselect",
    name: "which_products_are_you_most_interested_in_",
    isRequired: true,
    options: [
      "YuLife employee app",
      "Group Life Insurance",
      "Group Health Insurance",
      "Group Income Protection Insurance",
      "Group Dental Insurance",
    ].join("\n"),
  },
  COMPANY_NAME: {
    label: "Company name",
    type: "text",
    name: "company",
    isRequired: true,
  },
  HOW_CAN_WE_HELP: {
    label: "How can we help?",
    type: "select",
    name: "how_can_we_help____usa",
    isRequired: true,
    options: [
      "I am a business and would like a demo or quote",
      "I am an insurance carrier and interested in exploring a partnership",
      "I am an adviser and interested in exploring a partnership",
      "I am already a YuLife customer or have a client with YuLife and would like support",
      "Something else",
    ].join("\n"),
  },
  IS_THERE_ANYTHING_ELSE: {
    label: "Is there anything you'd like to tell us?",
    type: "text",
    name: "is_there_anything_else_you_d_like_to_tell_us_",
    isRequired: true,
    maxLength: 1000,
  },
};
